export const en = {
    carriage: 'Carriage',
    choose: 'Choose',
    choose_seat: 'Choose Seat',
    seats: 'Seats',
};
